import React, { useState, useEffect, useRef, forwardRef } from "react";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";

const RMultiSelect = forwardRef((props, ref) => {
  return (
    <div className="DropdownHeaderNIMP">
      {props.label}
      <Multiselect
        //  isObject={false}
        // className="dropdown-checkbox"
        // onKeyPressFn={(e)=>harsha(e)}
        onRemove={(e, r) => props.onChange(e, r)}
        style={{ searchBox: { minHeight: "15vh" } }}
        onSearch={function noRefCheck() {}}
        displayValue="name"
        groupBy="Group"
        ref={ref}
        // customCloseIcon=<CloseIcon fontSize="24px" />
        // singleSelect={SelectSubject?.length > 1}
        placeholder=""
        selectedValues={props.selected}
        // disable ="true"
        // selectedValueDecorator = {(e)=> e.split(' ')[1]}
        // optionValueDecorator = {(e)=> e.split(' ')[1]}
        avoidHighlightFirstOption="true"
        // disablePreSelectedValues="true"
        onSelect={(e, r) => props.onChange(e, r)}
        options={props.options}
        showCheckbox
      />
    </div>
  );
});

export function DDTopic(props) {
  const multiselectRef = useRef();
  const [TopicOptions, SetTopicOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=4&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          name: item.lovName,
          value: item.lovId,
          Group: "Topic's",
        }));
        SetTopicOptions(Options);
        const SOptions = Options.filter((item) =>
          props.Selected?.includes(item.value),
        );
        SetSelectedOptions(SOptions.length > 0 ? SOptions : [Options?.[0]]);
        const SelectedValues = SOptions.map((item) => item.value);
        props.StoreOptions(
          SelectedValues.length > 0 ? SelectedValues : [Options?.[0]?.value],
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.SubjectId && props.Preselected === 0) {
      SetTopicOptions();
      GetTopic();
    }
  }, [props.Preselected]);
  return (
    <>
      <RMultiSelect
        onChange={(e, r) => props.onChange(e, r)}
        selected={TopicOptions && SelectedOptions}
        ref={multiselectRef}
        options={TopicOptions}
        label="Topic :"
      />
    </>
  );
}

export function DDSubTopic(props) {
  const multiselectRef = useRef();
  const [SubTopicOptions, SetSubTopicOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetSubTopic = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBankByLO/GetSubTopicByTopic?TopicId=${props.Pid}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();

        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          })),
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value),
        );
        SetSelectedOptions(SOptions);
        SetSubTopicOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    props.clear("Topic");
    if (props.Pid) {
      // multiselectRef.current.resetSelectedValues();
      GetSubTopic();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetSubTopicOptions();
      // props.Selected([]);
    }
  }, [props.Pid]);

  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={SubTopicOptions}
      label="Sub Topic :"
    />
  );
}

export function DDLearningOC(props) {
  const multiselectRef = useRef();
  const [LearningOCOptions, SetLearningOCOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetLOC = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBankByLO/GetLOBySubTopic?SubTopicId=${props.Pid}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          })),
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value),
        );
        SetSelectedOptions(SOptions);
        SetLearningOCOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    props.clear("SubTopic");
    if (props.Pid) {
      GetLOC();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetLearningOCOptions();
    }
  }, [props.Pid]);
  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={LearningOCOptions}
      label="Learning Outcome :"
    />
  );
}

export function DDSubLearningOC(props) {
  const multiselectRef = useRef();
  const [SubLearningOCOptions, SetSubLearningOCOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetSubLOC = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBankByLO/GetSubLOByLO?LOId=${props.Pid}&SubjectId=${props.SubjectId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } },
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();

        if (res.data?.[0].lovDescription) {
          const Options = res.data?.map((item) => ({
            name: item.lovDescription,
            value: item.lovId,
            Group: item.parentLovName,
          }));
          const SOptions = Options.filter((item) =>
            props.Preselected?.includes(item.value),
          );
          SetSelectedOptions(SOptions);
          SetSubLearningOCOptions(Options);
        } else {
          SetSelectedOptions();
          SetSubLearningOCOptions([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (props.clear) {
      props.clear("LOC");
    }
    if (props.SubjectId && props.Pid) {
      GetSubLOC();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetSubLearningOCOptions();
    }
  }, [props.Pid]);
  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={SubLearningOCOptions}
      label=" Sub Learning Outcome :"
    />
  );
}
